import { Validators } from '@angular/forms';

import { SettingsFormType } from '@main-client/src/app/form/form.model';

import get from 'lodash-es/get';

export const defaultAdminLockoutTimeMinutes = 30;

export interface NotificationSettingsConfig {
  label: string;
  forms: {
    placeholder: string;
    updateKey: string;
  }[];
}

export const NOTIFICATION_EMAIL_SETTINGS = {
  label: `Select which email notifications you want to receive. Note: Changes may take a few days to take effect.`,
  forms: [
    {
      placeholder: 'Upcoming events in the community',
      updateKey: 'opt_in.events',
    },
    {
      placeholder: 'Office Hour reminders',
      updateKey: 'opt_in.groupchats',
    },
    {
      placeholder: 'Introductions reminders',
      updateKey: 'opt_in.matchmaking',
    },
    {
      placeholder: 'When I receive a new message',
      updateKey: 'opt_in.messages',
    },
    {
      placeholder: 'News and updates from Ten Thousand Coffees',
      updateKey: 'opt_in.newsletter',
    },
    {
      placeholder: 'Onboarding reminders',
      updateKey: 'opt_in.onboarding',
    },
    {
      placeholder: 'Emails related to Development Programs',
      updateKey: 'opt_in.programs',
    },
    {
      placeholder: 'When I receive a new coffee request',
      updateKey: 'opt_in.requests',
    },
  ],
};

export const CONTACT_HELP_DESK_BUTTON_CONFIG: any = {
  text: 'Contact Help Desk',
  raised: true,
};

export const CANCEL_PENDING_EMAIL_BUTTON_CONFIG: any = {
  text: 'Cancel Pending Email',
  canBeDisabled: true,
  color: 'primary',
  raised: true,
};
export const CHANGE_EMAIL_BUTTON_CONFIG: any = {
  text: 'Save',
  canBeDisabled: true,
  color: 'primary',
  raised: true,
};

export const UPDATE_TIMEZONE_BUTTON_CONFIG = {
  text: 'Update Timezone',
  canBeDisabled: true,
  color: 'primary',
  raised: true,
};

export const DELETE_PROFILE_BUTTON_CONFIG = {
  canBeDisabled: true,
  text: 'Delete My Profile',
  color: 'primary',
  raised: true,
  disable: false,
};

export function emailFormEnabled(tenant: any): boolean {
  return get(tenant, 'email_change_allowed');
}

export function allowEmailChangeSettings(tenant: any) {
  return {
    description: $localize`:@@adminSettingsView.allowEmailChange.description:Members can change email after joining`,
    forms: [
      {
        model: get(tenant, 'email_change_allowed'),
        updateKey: 'email_change_allowed',
      },
    ],
    title: {
      text: $localize`:@@adminSettingsView.allowEmailChange.title:Allow email change`,
    },
    type: 'static',
  };
}

export function emailSettingsConfig(tenant: any, user: any) {
  return {
    disableActionBar: true,
    forms: [
      {
        data: { placeholder: 'Your email address' },
        disable: true,
        label: emailFormEnabled(tenant)
          ? 'Email (Contact help@tenthousandcoffees.com to change your email address)'
          : 'Email (Changing emails is disabled for this community)',
        model: get(user, 'email'),
        showLabel: true,
        type: SettingsFormType.input,
        updateKey: 'password',
      },
    ],
    title: {
      primaryIcon: 'email',
      text: 'Change your email address',
    },
    type: 'static',
  };
}

export function timezoneSettingsConfig(user: any) {
  const userTimeZone = get(user, 'timezone');
  return {
    forms: [
      {
        data: {
          options: [
            {
              value: userTimeZone,
              text: userTimeZone,
            },
          ],
          placeholder: $localize`:@@settingsView.timezone.placeholder:Select a Timezone`,
        },
        model: userTimeZone,
        type: SettingsFormType.select,
        updateKey: 'timezone',
        validators: [Validators.required],
      },
    ],
    title: {
      text: 'Timezone',
      primaryIcon: 'lock',
    },
    type: 'static',
  };
}

export const SESSIONS_SETTINGS_CONFIG = {
  headerAction: {
    color: 'primary',
    text: 'View',
    type: 'icon',
  },
  title: {
    text: 'Sessions',
    primaryIcon: 'people',
  },
  type: 'static',
};

export function deleteAccountSettingsConfig(user: any) {
  return {
    containerClass: 'u-marginTop-24',
    disableForms: true,
    disableFormsText: get(user, 'isAdmin')
      ? `You cannot delete your account because you're an admin in one or more communities. To delete your account, please remove yourself as an Admin or contact our Help Desk.`
      : `Please note: Deleting your account will cause all of your existing conversations and profile information to be lost.`,
    title: {
      text: 'Delete Account',
    },
    type: 'expansion',
  };
}
